export default {"src":"/_next/static/media/krb.edd1a71b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};